import React from 'react';

const Logo = () => (
  <svg 
    width="120" 
    height="120" 
    viewBox="0 0 120 120" 
    xmlns="http://www.w3.org/2000/svg"
    className="nav-logo" // Keep existing class name
  >
    <g fill="#166534">
      <polygon points="20,30 40,30 60,70 40,70" />
      <polygon points="45,30 65,30 95,90 75,90" />
    </g>
  </svg>
);

export default Logo;

